<div class="event-data" [class.event-data--secondary]="variant() === 'secondary'">
  @let hasExternalVideoUrl = item().content.social_media?.external_url;
  @if (hasExternalVideoUrl && youtubePost) {
    <div class="embedded_content">
      <iframe
        width="100%"
        height="350"
        frameBorder="0"
        [src]="item().content.social_media?.external_url | youtubeEmbed"
      ></iframe>
    </div>
  } @else if (hasExternalVideoUrl && tiktokPost) {
    <div class="embedded_content">
      <iframe
        width="100%"
        height="600"
        frameBorder="0"
        sandbox="allow-scripts allow-same-origin allow-popups"
        allow="encrypted-media"
        [src]="item().content.social_media?.external_url | tiktokEmbed"
      ></iframe>
    </div>
  }

  @if (hasVideo) {
    <div class="video-container">
      <div #videoVisibility style="position: absolute; height: 1px; width: 100%"></div>

      <video
        #videoElement
        class="social-video"
        [src]="item().content.videos[0].video_url"
        [muted]="isMuted"
        loop
        playsinline
        (click)="toggleMute($event)"
      ></video>
      <div class="sound-control" (click)="toggleMute($event)">
        <span class="icon" [class.outlaw-icon-sound]="!isMuted" [class.outlaw-icon-no-sound]="isMuted"></span>
      </div>
    </div>
  } @else if (mappedImages().length > 0 && !youtubePost && !tiktokPost) {
    <div class="embedded_content">
      <app-slider [images]="mappedImages()" [openInSameWindow]="openInSameWindow()" (navigateToPost)="onPostClick()" />
    </div>
  }

  <div class="info-block">
    <span class="date">{{ item().posted_at | unixDateFormatter }}</span>
    @if (item().content.social_media?.external_username) {
      <div class="dot">•</div>
      @if (userUrl) {
        <a [olExternalLink]="userUrl" class="outlaw-link" [target]="linkTarget" [isMajiApp]="isMajiApp()">
          {{ item().content.social_media.external_username }}
        </a>
      } @else {
        <span class="platform">
          {{ item().content.social_media.external_username }}
        </span>
      }
    }
  </div>

  <app-text-content
    class="text-content"
    [class.text-content--secondary]="variant() === 'secondary'"
    [title]="item().content.title"
    [text]="item().content.text"
    [postUrl]="postUrl()"
    [maxTextLength]="isInstagramPost && variant() === 'primary' ? maxTextLength : undefined"
    [openInSameWindow]="openInSameWindow()"
    (postClick)="onPostClick()"
  />
</div>
